import React from 'react';

import Close from '../../svg/Close';

const DrawerHeader = props => {
  const { title, handleClose, subtitle, xIsLeft = false } = props;
  let closeClasses = 'client-dash-drawer__close';
  if (xIsLeft) closeClasses += ' client-dash-drawer__close--left';

  return (
    <div className="client-dash-drawer__heading-wrap">
      <div className="client-dash-drawer__heading-wrap-inner">
        <button className={closeClasses} onClick={handleClose}>
          <Close />
        </button>
        <div>
          <h2 className="client-dash-drawer__heading">{title}</h2>
          {subtitle && (
            <h2 className="client-dash-drawer__heading">{subtitle}</h2>
          )}
        </div>
      </div>
      {props.children}
    </div>
  );
};

export default DrawerHeader;



// WEBPACK FOOTER //
// ./src/components/new/DrawerHeader.js